import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import ScrollTop from 'components/ScrollToTop';
import MembershipAgreement from 'modules/public/views/MembershipAgreement';
import Login from 'containers/login';
import ForgotPassword from 'containers/forgot-password';
import ResetPassword from 'containers/reset-password';
import CreatePassword from 'containers/create-password';
import NotFound from 'containers/not-found';
import ServerError from 'containers/server-error';
import { connect } from 'react-redux';
import DCC from 'modules/dcc';
import ConnectCard from 'modules/connect-card-widget/containers/connect-card/CardPage';
import ConnectPoint from 'modules/connect-card-widget/containers/connect-point';
import {
  OnboardingModule,
  AppLayout,
  Admin,
  CheckoutModule,
  PLOnboardingModule,
} from 'Routes';
import { restoreToken, getMe } from 'store/modules/user/actions';
import MetaTags from 'modules/public/components/MetaTags';
import VideoMessage from 'modules/videos/containers/VideoMessage';
import NotePage from 'modules/notes/containers/ViewNote';
import UnsubscribePage from 'modules/public/views/Unsubscribe';
import WeBelieve from 'modules/public/views/WeBelieve';
import cookie from 'utils/cookie';
import AuthWrapper from 'components/AuthWrapper';

const AppRoutes = () => {
  return (
    <>
      <Switch>
        <Route exact path="/webelieve">
          <AuthWrapper>
            <WeBelieve />
          </AuthWrapper>
        </Route>
        <Route path="/agreement" component={MembershipAgreement} />
        <Route path="/unsubscribe" component={UnsubscribePage} />
        <Route path="/setup" component={OnboardingModule} />
        <Route path="/plsetup" component={PLOnboardingModule} />
        <Route path="/login" component={Login} />
        <Route path="/signin" component={Login} />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/reset-password" component={ResetPassword} />
        <Route path="/create-password" component={CreatePassword} />
        <Route
          exact
          path="/groups/:type(\w+form\w*)/:groupId/:contactId?"
          component={DCC}
        />
        <Route
          exact
          path="/connect-cards/:id/:contactHash?"
          component={ConnectCard}
        />
        <Route exact path="/connect-pages/:id" component={ConnectPoint} />
        <Route exact path="/page/:id" component={VideoMessage} />
        <Route exact path="/note/:id" component={NotePage} />
        <Route path="/admin" component={Admin} />
        <Route exact path="/404" component={NotFound} />
        <Route exact path="/error" component={ServerError} />
        <Route path="/" component={AppLayout} />
      </Switch>
    </>
  );
};

class Main extends React.Component {
  componentDidMount() {
    try {
      const token = cookie.get('token');
      if (token && !this.props.isLoggedIn) {
        this.props.restoreToken(token);
      }
    } catch (e) {
      console.log(e);
    }
  }

  render() {
    return (
      <React.Fragment>
        <ScrollTop />
        <MetaTags />
        <ToastContainer
          hideProgressBar
          icon={false} // TODO update with new apis
          autoClose={5000}
          closeButton={false}
          className="toast-container"
        />
        <Switch>
          <Route
            exact
            path={[
              '/checkout',
              '/checkout/complete',
              '/offer',
              '/offer/confirm',
            ]}
            component={CheckoutModule}
          />
          <Route component={AppRoutes} />
        </Switch>
      </React.Fragment>
    );
  }
}

export default connect((state) => state.user, { restoreToken, getMe })(
  withRouter(Main),
);
